const _excluded = ["children", "theme"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useState, useEffect } from 'react';
import proptypes from 'prop-types';
const {
  node,
  func
} = proptypes;
import { ThemeContext } from "./ThemeContext.js";
const ThemeProvider = _ref => {
  let {
      children,
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const value = {
    theme,
    props
  };
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: value
  }, children);
};
ThemeProvider.propTypes = {
  children: node.isRequired,
  theme: func
};
ThemeProvider.defaultProps = {
  theme: null
};
ThemeProvider.displayName = 'ThemeProvider';
export { ThemeProvider };
//# sourceMappingURL=ThemeProvider.js.map